(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-components/assets/javascripts/bet-buttons.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-components/assets/javascripts/bet-buttons.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const _svs$components$tipse = svs.components.tipsen.couponComponents,
  Coupon = _svs$components$tipse.Coupon,
  useCouponContext = _svs$components$tipse.useCouponContext;
const TipsenBetButton = svs.components.lbUi.tipsenBetButton.TipsenBetButton;
const toggleOutcome = svs.components.tipsen.engine.actions.toggleOutcome;
const useBranding = svs.components.tipsen.hooks.useBranding;
const selectSystemType = svs.components.tipsen.engine.selectors.couponSelectors.selectSystemType;
const SYSTEM_REDUCERA_FRITT = svs.components.tipsen.engine.constants.systems.SYSTEM_REDUCERA_FRITT;
const TrendIndicator = svs.components.tipsen.trendIndicator.TrendIndicator;
const percentage = signDistribution => {
  const signDistributionPercentage = [];
  const totalRowValue = signDistribution.reduce((a, b) => a + b, 0);
  signDistributionPercentage[0] = signDistribution[0] ? "".concat(Math.round(signDistribution[0] / totalRowValue * 100), "%") : "".concat(0, "%");
  signDistributionPercentage[1] = signDistribution[1] ? "".concat(Math.round(signDistribution[1] / totalRowValue * 100), "%") : "".concat(0, "%");
  signDistributionPercentage[2] = signDistribution[2] ? "".concat(Math.round(signDistribution[2] / totalRowValue * 100), "%") : "".concat(0, "%");
  return signDistributionPercentage;
};
const getBetOptionSign = (betOption, index, signDistribution, systemType) => {
  if (systemType === SYSTEM_REDUCERA_FRITT) {
    const percentages = percentage(signDistribution);
    return percentages[index];
  }
  return betOption.sign;
};
const BetButtons = _ref => {
  let _ref$boardIndex = _ref.boardIndex,
    boardIndex = _ref$boardIndex === void 0 ? 0 : _ref$boardIndex,
    _ref$buttonClassName = _ref.buttonClassName,
    buttonClassName = _ref$buttonClassName === void 0 ? '' : _ref$buttonClassName,
    _ref$distributions = _ref.distributions,
    distributions = _ref$distributions === void 0 ? [] : _ref$distributions,
    _ref$eventNumber = _ref.eventNumber,
    eventNumber = _ref$eventNumber === void 0 ? 0 : _ref$eventNumber,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$isClickable = _ref.isClickable,
    isClickable = _ref$isClickable === void 0 ? false : _ref$isClickable,
    _ref$outcomeGroupInde = _ref.outcomeGroupIndex,
    outcomeGroupIndex = _ref$outcomeGroupInde === void 0 ? 0 : _ref$outcomeGroupInde,
    _ref$outcomes = _ref.outcomes,
    outcomes = _ref$outcomes === void 0 ? [] : _ref$outcomes,
    _ref$outcomeCount = _ref.outcomeCount,
    outcomeCount = _ref$outcomeCount === void 0 ? 0 : _ref$outcomeCount,
    _ref$signDistribution = _ref.signDistribution,
    signDistribution = _ref$signDistribution === void 0 ? [] : _ref$signDistribution,
    _ref$signLabel = _ref.signLabel,
    signLabel = _ref$signLabel === void 0 ? '' : _ref$signLabel;
  const _useCouponContext = useCouponContext(),
    couponId = _useCouponContext.couponId;
  const _useBranding = useBranding(),
    _useBranding2 = _slicedToArray(_useBranding, 1),
    productBranding = _useBranding2[0];
  const systemType = useSelector(state => selectSystemType(state, couponId));
  const isReduceFree = systemType === SYSTEM_REDUCERA_FRITT;
  const dispatch = useDispatch();
  const classNames = ['pg_bet_buttons'];
  if (className) {
    classNames.push(className);
  }
  const handleClick = (outcomeValue, e) => {
    e.preventDefault();
    const boardIndex = 0;
    dispatch(toggleOutcome({
      boardIndex,
      couponId,
      eventNumber,
      outcome: outcomeValue,
      systemType,
      outcomeGroupIndex
    }));
  };
  const hasMatchingDistributions = outcomeCount > 0 && outcomeCount === distributions.length;
  return React.createElement("div", {
    className: classNames.join(' '),
    role: "group"
  }, signLabel && React.createElement("div", {
    "aria-label": "matematisk gardering",
    className: "f-normal"
  }, signLabel), outcomes.map((betOption, index) => {
    const dataTestId = "bet_button_".concat(boardIndex, "_").concat(eventNumber, "_").concat(outcomeGroupIndex, "_").concat(index);
    const key = "bet_button_".concat(index + 1, "_").concat(betOption.sign);
    const trendIndicatorKey = "".concat(couponId, "_").concat(index);
    if (hasMatchingDistributions) {
      return React.createElement("div", {
        className: "pg_bet_buttons__button_wrapper",
        key: key
      }, React.createElement(TipsenBetButton, {
        ariaLabel: betOption.ariaLabel,
        branding: productBranding,
        className: buttonClassName,
        dataTestId: dataTestId,
        handleClick: e => handleClick(betOption.outcomeValue, e),
        hasUSign: betOption.hasUSign,
        isClickable: isClickable,
        isReduceFree: isReduceFree,
        isSelected: betOption.isSelected,
        sign: getBetOptionSign(betOption, index, signDistribution, systemType)
      }), (distributions === null || distributions === void 0 ? void 0 : distributions.length) === outcomeCount && React.createElement("div", {
        className: "pg_bet_buttons__distribution"
      }, React.createElement(TrendIndicator, {
        id: trendIndicatorKey,
        key: trendIndicatorKey,
        suffix: "%",
        value: (distributions === null || distributions === void 0 ? void 0 : distributions[betOption.sign]) || 0
      })));
    }
    return React.createElement(TipsenBetButton, {
      ariaLabel: betOption.ariaLabel,
      branding: productBranding,
      className: buttonClassName,
      dataTestId: dataTestId,
      handleClick: e => handleClick(betOption.outcomeValue, e),
      hasUSign: betOption.hasUSign,
      isClickable: isClickable,
      isReduceFree: isReduceFree,
      isSelected: betOption.isSelected,
      key: key,
      sign: getBetOptionSign(betOption, index, signDistribution, systemType)
    });
  }));
};
Coupon.BetButtons = BetButtons;

 })(window);